import { CEAssessmentBase } from './ce-assessment-base'


export class CEAssessment extends CEAssessmentBase {

}